import { Component } from '@angular/core';

/**
 * "Promotions available" capsule — iOS `PromotionView`.
 *
 * Backed by `relatedVoucherIDs`, which is empty on every document in both projects, so this has
 * never rendered on any platform. Ported anyway because it is a pure function of the data: the day
 * a voucher is attached to an event, every client shows the badge with no release needed. Callers
 * gate on `hasPromotion()`.
 */
@Component({
    selector: 'app-event-promotion-badge',
    template: `
    <span class="ev-promo">
      <app-event-icon name="ticket" [size]="14"></app-event-icon>
      <span class="ev-promo-label">{{ 'events.promotionsAvailable' | translate }}</span>
    </span>
  `,
    styles: [`
    :host { display: inline-flex; }
    .ev-promo {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 5px 10px;
      border-radius: 999px;
      /* iOS layers a 30% red over 70% black; flattened here to one rgba so the capsule composites
         the same over an image as it does over a solid card. */
      background: rgba(77, 34, 35, 0.85);
      border: 1px solid var(--ev-date-badge, #FF6064);
      color: var(--ev-on-surface, #FFFFFF);
    }
    .ev-promo-label {
      font-size: 12px;
      line-height: 1.2;
      white-space: nowrap;
    }
  `],
    standalone: false
})
export class EventPromotionBadgeComponent {}
